module.exports = __webpack_public_path__ + "static/media/roboto4.479970ff.woff2";